/* unplugin-vue-components disabled */import script from "./QuickDicePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickDicePicker.vue?vue&type=script&setup=true&lang=js"

import "./QuickDicePicker.vue?vue&type=style&index=0&id=053f6599&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053f6599"]])

export default __exports__